import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box, Flex, Stack, Text
} from '@chakra-ui/react'
import { LoadingSpinier } from 'common/Loading'
import * as sdk from 'matrix-js-sdk'

import { getMatrixClient } from '../Matrix/clientStore'

import { ContactList } from './ContactsList'

export const MessengerChatUI = ({
  matrixStatus,
  matrixError,
  rooms,
  matrixMessagesbyRoomId,
  avatarMap
}) => {
  const [page, setPage] = useState('contacts')

  const handleChatList = () => {
    const chatList = rooms
    const client = getMatrixClient()

    return chatList
      .filter((room) => {
        const count = client?.getRoom(room?.roomId)?.getJoinedMemberCount() ?? 0
        return page === 'contacts' ? count <= 2 : count > 2
      })
      .map((room) => {
        const roomItem = client?.getRoom(room?.roomId)

        // Get MXC URL
        const mxcUrl = roomItem?.getMxcAvatarUrl()
      ?? roomItem?.getAvatarFallbackMember()?.getMxcAvatarUrl()

        // Avatar URL
        const avatarUrl = mxcUrl
          ? client?.mxcUrlToHttp(mxcUrl, 96, 96, 'crop', false, true, true)
          : null

        // Last message
        const events = roomItem?.getLiveTimeline().getEvents() ?? []
        const lastMsgEvent = [...events].reverse().find(
          (e) => e.getType() === 'm.room.message' && !e.isRedacted()
        )
        const lastMessage = lastMsgEvent?.getContent()?.body ?? ''

        return (<ContactList name={room.name} avatarUrl={avatarUrl} lastMessage={lastMessage} />)
      })
  }

  const handleChangePage = (pageItem) => {
    setPage(pageItem) // 'contacts' or 'groups'
  }

  return getMatrixClient()
    ? (
      <Stack
        className="messenger-chat-wrapper"
        height="100%"
        width="100%"
        position="relative"
        overflow="hidden"
        backgroundColor="#282828"
      >
        <Stack height="40px" alignItems="center" justifyContent="center" marginY="10px">
          <Flex direction="row" gap="32" fontSize="20px">
            <Box padding="5px" borderRadius="full" backgroundColor={page === 'contacts' ? '#ebc700' : 'transparent'} cursor="pointer" onClick={() => handleChangePage('contacts')}>
              <Text color="white">
                Contacts
              </Text>
            </Box>
            <Box padding="5px" borderRadius="full" backgroundColor={page === 'groups' ? '#ebc700' : 'transparent'} cursor="pointer" onClick={() => handleChangePage('groups')}>
              <Text color="white">
                Groups
              </Text>
            </Box>
          </Flex>
        </Stack>
        {/* <ContactList /> */}
        {handleChatList()}
      </Stack>
    )
    : (<LoadingSpinier />)
}
